import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserById } from "../../redux/user/userThunks";
import { clearUserData } from "../../redux/user/userSlice";
import ClubListLayer from "../Club/ClubListLayer";
import BookingListLayer from "../Booking/BookingListLayer";
import moment from "moment";

const ViewUserPageNew = ({ roles }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { userData, loading } = useSelector((state) => state.user);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("view-user");

  useEffect(() => {
    dispatch(fetchUserById({ id, navigate }));
    return () => {
      dispatch(clearUserData());
    };
  }, [id, navigate, dispatch]);

  const calculateAge = (dob) => {
    if (!dob) return null;
    const date = new Date(dob);
    return Math.floor((new Date() - date) / (365.25 * 24 * 60 * 60 * 1000));
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {/* Alerts */}
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {/* Tab Navigation */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="user-view-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${
                    activeTab === "view-user" ? "active" : ""
                  }`}
                  id="tab-view-user"
                  type="button"
                  role="tab"
                  onClick={() => setActiveTab("view-user")}
                >
                  User Profile
                </button>
              </li>

              {/* Show Host Event tab only if role = host */}
              {roles === "host" && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link d-flex align-items-center px-24 ${
                      activeTab === "view-host-events" ? "active" : ""
                    }`}
                    id="tab-view-host-events"
                    type="button"
                    role="tab"
                    onClick={() => setActiveTab("view-host-events")}
                  >
                    Hosting Details
                  </button>
                </li>
              )}

              {/* Show Booking tab only if role = user */}
              {roles === "user" && (
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link d-flex align-items-center px-24 ${
                      activeTab === "view-booking" ? "active" : ""
                    }`}
                    id="tab-view-booking"
                    type="button"
                    role="tab"
                    onClick={() => setActiveTab("view-booking")}
                  >
                    Booking Details
                  </button>
                </li>
              )}
            </ul>

            {/* Tab Content */}
            <div className="tab-content" id="user-tab-content">
              {/* User Profile Tab */}
              <div
                className={`tab-pane fade ${
                  activeTab === "view-user" ? "show active" : ""
                }`}
                id="tab-content-view-user"
                role="tabpanel"
              >
                <div className="row">
                  <p
                    style={{ fontWeight: "bold", textDecoration: "underline" }}
                  >
                    User Detail
                  </p>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Name:
                    </label>
                    {userData?.fullName || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Email:
                    </label>
                    {userData?.email || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">Age:</label>
                    {calculateAge(userData?.dateOfBirth) || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Role:
                    </label>
                    {userData?.currentRole || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Status:
                    </label>
                    {userData?.status || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Login Type:
                    </label>
                    {userData?.loginType || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Email Verified At:
                    </label>
                    {userData?.emailVerify
                      ? moment(userData.emailVerify).format("DD-MM-YYYY")
                      : "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Date Of Birth:
                    </label>
                    {userData?.dateOfBirth
                      ? moment(userData.dateOfBirth).format("DD-MM-YYYY")
                      : "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Address:
                    </label>
                    {userData?.location?.address || "N/A"}
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold me-2 mb-0">
                      Phone Number:
                    </label>
                    {userData?.phone || "N/A"}
                  </div>
                </div>
                <div>
                  <div className="row">
                    <p
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                    >
                      Business Detail
                    </p>
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label className="form-label fw-bold me-2 mb-0">
                          Business Name:
                        </label>
                        {userData?.businessName || "N/A"}
                      </div>
                      <div className="col-md-8 mb-3">
                        <label className="form-label fw-bold me-2 mb-0">
                          Business Discription:
                        </label>
                        {userData?.businessDiscription || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>

                {/* User Images Section */}
                <div className="col-md-12 mt-4">
                  <div className="row g-3">
                    {/* Profile Picture */}
                    {userData?.profilePicture && (
                      <div className="col-md-3">
                        <label className="form-label fw-bold mb-1">
                          Profile Picture:
                        </label>
                        <img
                          src={userData.profilePicture}
                          alt="Profile"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            width: "100%",
                            maxHeight: "180px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                           onClick={() => window.open(userData.profilePicture, "_blank")}
                        />
                      </div>
                    )}

                    {/* Business License */}
                    {userData?.userDocument && (
                      <div className="col-md-3">
                        <label className="form-label fw-bold mb-1">
                          Business License:
                        </label>
                        {(() => {
                          const fileUrl = userData.userDocument;
                          const fileExtension = fileUrl
                            .split(".")
                            .pop()
                            .toLowerCase();
                          const isImage = [
                            "jpg",
                            "jpeg",
                            "png",
                            "gif",
                            "webp",
                          ].includes(fileExtension);

                          return isImage ? (
                            // ✅ Image preview (click opens in new tab)
                            <img
                              src={fileUrl}
                              alt="Business License"
                              className="img-fluid rounded shadow-sm"
                              style={{
                                width: "100%",
                                maxHeight: "180px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                              onClick={() => window.open(fileUrl, "_blank")}
                            />
                          ) : (
                            // ✅ PDF file (shows icon, click opens in new tab)
                            <div
                              className="d-flex flex-column align-items-center justify-content-center border rounded shadow-sm p-3"
                              style={{ height: "180px", cursor: "pointer" }}
                              onClick={() => window.open(fileUrl, "_blank")}
                            >
                              <i className="bi bi-file-earmark-pdf fs-1 text-danger"></i>
                              <span className="mt-2 fw-bold text-danger">
                                View PDF
                              </span>
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {/* Business Picture */}
                    {userData?.businessPicture && (
                      <div className="col-md-3">
                        <label className="form-label fw-bold mb-1">
                          Business Picture:
                        </label>
                        <img
                          src={userData.businessPicture}
                          alt="Business Picture"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            width: "100%",
                            maxHeight: "180px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => window.open(userData.businessPicture, "_blank")}
                        />
                      </div>
                    )}

                    {/* Business Banner */}
                    {userData?.businessBanner && (
                      <div className="col-md-3">
                        <label className="form-label fw-bold mb-1">
                          Business Banner:
                        </label>
                        <img
                          src={userData.businessBanner}
                          alt="Business Banner"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            width: "100%",
                            maxHeight: "180px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                           onClick={() => window.open(userData.businessBanner, "_blank")}
                        />
                      </div>
                    )}
                  </div>

                  {/* Fallback */}
                  {!userData?.profilePicture &&
                    !userData?.userDocument &&
                    !userData?.businessPicture &&
                    !userData?.businessBanner && (
                      <p className="text-muted mt-2">No images available.</p>
                    )}
                </div>
              </div>

              {/* Booking Details Tab (for user) */}
              {roles === "user" && (
                <div
                  className={`tab-pane fade ${
                    activeTab === "view-booking" ? "show active" : ""
                  }`}
                  id="tab-content-view-booking"
                  role="tabpanel"
                >
                  <div className="row">
                    <BookingListLayer userId={id} />
                  </div>
                </div>
              )}

              {/* Host Events Tab (for host) */}
              {roles === "host" && (
                <div
                  className={`tab-pane fade ${
                    activeTab === "view-host-events" ? "show active" : ""
                  }`}
                  id="tab-content-view-host-events"
                  role="tabpanel"
                >
                  <div className="row">
                    <ClubListLayer userId={id} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewUserPageNew;
